"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function cov_12w1i31hhh() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/OfferInactive.tsx";
  var hash = "cca1638ddaee0b74f4dde7f6b17fa7b535beb762";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/OfferInactive.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 54
        },
        end: {
          line: 7,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "cca1638ddaee0b74f4dde7f6b17fa7b535beb762"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_12w1i31hhh = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_12w1i31hhh();
var Icon = (cov_12w1i31hhh().s[0]++, {
  name: 'offer-inactive',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18 4.5H6C5.72386 4.5 5.5 4.72386 5.5 5V19C5.5 19.2761 5.72386 19.5 6 19.5H18C18.2761 19.5 18.5 19.2761 18.5 19V5C18.5 4.72386 18.2761 4.5 18 4.5ZM6 2C4.34315 2 3 3.34315 3 5V19C3 20.6569 4.34315 22 6 22H18C19.6569 22 21 20.6569 21 19V5C21 3.34315 19.6569 2 18 2H6Z\" fill=\"currentColor\"/>\n  <path d=\"M9.5 8.0498C9.5 8.74016 8.94036 9.2998 8.25 9.2998C7.55964 9.2998 7 8.74016 7 8.0498C7 7.35945 7.55964 6.7998 8.25 6.7998C8.94036 6.7998 9.5 7.35945 9.5 8.0498Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.75 12C6.75 11.3096 7.30964 10.75 8 10.75H16C16.6904 10.75 17.25 11.3096 17.25 12C17.25 12.6904 16.6904 13.25 16 13.25H8C7.30964 13.25 6.75 12.6904 6.75 12Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.75 16C6.75 15.3096 7.30964 14.75 8 14.75H16C16.6904 14.75 17.25 15.3096 17.25 16C17.25 16.6904 16.6904 17.25 16 17.25H8C7.30964 17.25 6.75 16.6904 6.75 16Z\" fill=\"currentColor\"/>"
});
var _default = exports["default"] = Icon;